// Due to continue support of iOS 9-10 for the mobile app (and IE11 for the main site),
// we should not used named capture groups. Babel states the browser must have ES6 regular
// expression features for them to work even after compilation.
// https://babeljs.io/docs/en/babel-plugin-transform-named-capturing-groups-regex

export const iso8601Regex = /^(\d{4}-[01]\d-[0-3]\d)(T([0-2]\d:[0-5]\d:[0-5]\d(\.\d+)?)(([+-][0-2]\d:[0-5]\d)|Z))?$/;

iso8601Regex.groups = Object.freeze({
  date: 1,
  time: 3,
  offset: 5
});

export const durationRegex = /^((\d+)\.)?([0-2]\d):([0-5]\d):([0-5]\d)(\.(\d{1,3}))?((?=\d+$)|$)/;

durationRegex.groups = Object.freeze({
  days: 2,
  hours: 3,
  minutes: 4,
  seconds: 5,
  milliseconds: 7
});

export const timeSpanFormat = 'HH:mm:ss.SSS';
